import * as types from '../../mutation_types';
import { https,httpsFile } from './http';

const state = {
    page:1,
    currentpage:5,
    loading:false,
    search:'',
    data:{},
    material_type:['HAWA','ZVKI']
};
const getters = {
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    loading:state=>state.loading,
    search:state=>state.search,
    data:state=>state.data,
    material_type:state=>state.material_type
};
const actions = {
    async fetchMaterials({commit}){
        commit(types.MOS_LOADING);
        let uri = `/materialmaster?search=${state.search}&page=${state.page}&currentpage=${state.currentpage}&material_type=${state.material_type}`;
        await https().get(uri).then((response)=>{
            commit(types.MOS_DATA,response.data);
        }).catch((error)=>{ console.log(error) });
        commit(types.MOS_LOADING);
    }

};
const mutations = {
    [types.MOS_PAGE](state,data){
        state.page = data;
    },
    [types.MOS_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.MOS_LOADING](state){
        state.loading = !state.loading;
    },
    [types.MOS_SEARCH](state,data){
        state.search = data;
    },
    [types.MOS_DATA](state,data){
        state.data = data;
    },
    [types.MOS_CLEAR](state){
        state.page=1;
        state.currentpage=5;
        state.search='';
        state.data={};
        state.material_type=['HAWA','ZVKI'];
    }
};
export {
    state,getters,actions,mutations
}